export default "__VITE_ASSET__8b6741f8__"